import { useParams } from "react-router-dom";

export default function usePublishedId() {
  return useParams().publishedId;
}
